export default __webpack_public_path__ + "static/media/signPoseLogo.5f155e4a.png";